var exports = {
  "c": "reset__Dj740Z",
};

module.exports = exports;
